import _ from 'lodash'

window.addEventListener('load', function () {
    /* Back to top
    ---------------------------------------------------------------------------------------------------- */
    let scrollToTop = function (ev) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        })
    }
    const $btnScrollTop = document.querySelectorAll('.footer-backtotop')

    if ($btnScrollTop.length > 0) {
        for (let bEl of $btnScrollTop) {
            bEl.addEventListener('click', scrollToTop)
        }
    }

    /* Sticky menu
    ---------------------------------------------------------------------------------------------------- */
    document.addEventListener('scroll', () => {
        stickyNavbar()
    })

    stickyNavbar()
})

const stickyNavbar = () => {
    const header = document.querySelector('header')
    if (window.scrollY > 5) {
        header.classList.add('scrolled')
    } else {
        header.classList.remove('scrolled')
    }
}
